import axios from '@/plugins/axios'

export default {
    getAll() {
        return axios.rasaApi.get(`/user`)
    },
    getUserMe() {
        return axios.rasaApi('/user/me')
    },
}